module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-order"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('steps-bar', {
    attrs: {
      "steps": _vm.steps,
      "curr-step-index": this.currStepIndex
    },
    on: {
      "select": _vm.handleStepSelect
    }
  })], 1), _vm._v(" "), (_vm.errors && _vm.errors.length) ? _c('div', {
    staticClass: "gl-alert_padding"
  }, [(_vm.errors && _vm.errors.length) ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.errors), function(e) {
    return _c('div', [_vm._v(_vm._s(e.message))])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [(_vm.currStep.key == 'customer') ? _c('customer-step', {
    attrs: {
      "validate-errors": _vm.customerValidationErrors
    },
    on: {
      "input": _vm.handleCustomerDataChange
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currStep.key == 'check') ? _c('check-step', {
    attrs: {
      "customer": _vm.customer,
      "cart": _vm.cart,
      "total-price": _vm.totalPrice,
      "total-count": _vm.totalCount
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currStep.key == 'finish') ? _c('finish-step', {
    attrs: {
      "order": _vm.order
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isFinish) ? _c('div', {
    staticClass: "buttons"
  }, [(!_vm.isStepFirst) ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.handlePrevStep()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "arrow-left",
      "scale": "1"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Назад")])]) : _vm._e(), _vm._v(" "), (!_vm.isFinish) ? _c('button', {
    class: [{
      'is-loading': _vm.loading
    }, 'button', 'is-primary'],
    attrs: {
      "disabled": _vm.loading || _vm.hasValidationErrors
    },
    on: {
      "click": function($event) {
        _vm.handleNextStep()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "check",
      "scale": "1"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Продолжить")])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("Ошибка")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f07004e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/order/Widget.vue
// module id = 659
// module chunks = 2